import React from "react";
import useLocalStorage from "../../hooks/useLocalStorage";

function Test() {
  // const { Item, changeItem } = useLocalStorage("payment process", "0");

  return (
    <div>
      {/* <input
        onChange={(e) => {
          changeItem(e.target.value);
        }}
      ></input>
      <p>your step is {Item}</p> */}
    </div>
  );
}

export default Test;
